<template>
    <div :class="[
        'form-group', {
            'has-error': hasErrors,
            'form-group--disabled': disabled,
        }]">
        <label :for="name" class="control-label">
            <slot>{{ name }}</slot>{{ required ? ' *' : '' }}
        </label>

        <el-date-picker
            class="form-control"
            v-bind="$attrs"
            v-model="value"
            :id="name"
            :name="name"
            :type="type"
            :required="required"
            :disabled="disabled" />

        <div v-if="hasErrors" class="form-group__errors">
            <p>{{ errors[0] }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SaxxDatePicker',
    props: {
        form: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String
        },
        type: {
            required: false,
            type: String,
            default: 'date'
        },
        required: {
          required: false,
          type: Boolean,
          default: false
        },
    },
    computed: {
        ...mapGetters('forms', [
            'getErrors',
            'getField',
            'getFieldIsDisabled',
        ]),
        value: {
          get() {
            return this.getField({
              form: this.form,
              field: this.name,
            });
          },
          set(value) {
            this.setField({
                form: this.form,
                field: this.name,
                value,
            });
          },
        },
        errors() {
            return this.getErrors({
                form: this.form,
                field: this.name,
            });
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        disabled() {
            return this.getFieldIsDisabled({ form: this.form, field: this.name });
        },
    },
    methods: {
        ...mapActions('forms', [
            'setField',
        ]),
    },
}
</script>
